module.exports = __webpack_public_path__ + "jizvy_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/jizvy_2_before.jpg
// module id = 952
// module chunks = 0